/**
 * Utility functions for URL handling
 */

// Get the API base URL without /api suffix for static files
const getStaticBaseUrl = (): string => {
  // Get API URL from Vite environment variables
  const viteApiUrl = (import.meta as any).env?.VITE_API_URL;
  
  let apiUrl: string;
  
  if (viteApiUrl) {
    apiUrl = viteApiUrl;
  } else if (typeof window !== 'undefined') {
    // Fallback: construct from current window location
    const protocol = window.location.protocol;
    const host = window.location.host;
    apiUrl = `${protocol}//${host}/api`;
  } else {
    // Final fallback for development
    apiUrl = "http://localhost:5000/api";
  }
  
  const baseUrl = apiUrl.replace('/api', '');
  
  return baseUrl;
};

/**
 * Convert a profile photo path to a full URL
 * @param photoPath - The photo path from the backend (e.g., "/uploads/profiles/photo.jpg")
 * @returns Full URL or null if no photo
 */
export const getProfilePhotoUrl = (photoPath: string | null | undefined): string | null => {
  if (!photoPath) {
    return null;
  }

  // If it's already a full URL, return as-is
  if (photoPath.startsWith('http://') || photoPath.startsWith('https://')) {
    return photoPath;
  }

  // If it's a relative path, prepend the base URL
  const baseUrl = getStaticBaseUrl();
  return `${baseUrl}${photoPath}`;
};

/**
 * Convert any upload path to a full URL
 * @param uploadPath - The upload path from the backend (e.g., "/uploads/groups/photo.jpg")
 * @returns Full URL or null if no path
 */
export const getUploadUrl = (uploadPath: string | null | undefined): string | null => {
  if (!uploadPath) {
    return null;
  }

  // If it's already a full URL, return as-is
  if (uploadPath.startsWith('http://') || uploadPath.startsWith('https://')) {
    return uploadPath;
  }

  // If it's a relative path, prepend the base URL
  const baseUrl = getStaticBaseUrl();
  return `${baseUrl}${uploadPath}`;
};